import React from "react";

const CTASection: React.FC = () => {
  return (
    <section className="bg-green-600 text-white py-16 px-6 text-center">
      <h2 className="text-3xl font-bold mb-4">Start Managing Smarter with Tadwiro</h2>
      <p className="mb-6 text-lg">
        Request a demo or contact us to understand how Tadwiro can simplify your operations.
      </p>
      <a
        href="/contact"
        className="bg-white text-green-700 px-6 py-3 rounded-full font-semibold hover:bg-gray-100 transition"
      >
        Get in Touch
      </a>
    </section>
  );
};

export default CTASection;